import { oc } from "@orpc/contract";
import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";

const AutomationEntityActionSchema = z.enum(["create", "update", "delete"]);

export const ListAutomationEntityModificationsInputSchema = z.object({
  entityType: z.enum(SystemEntity),
  entityId: z.uuid(),
});

export const AutomationEntityModificationItemSchema = z.object({
  id: z.uuid(),
  action: AutomationEntityActionSchema,
  createdAt: z.coerce.date(),
  stepRunId: z.uuid().nullable(),
  agentMessageId: z.uuid().nullable(),
  workflowRun: z
    .object({
      id: z.uuid(),
      status: z.string(),
      startedAt: z.coerce.date().nullable(),
      completedAt: z.coerce.date().nullable(),
      workflowDefinitionId: z.uuid(),
      workflowName: z.string().nullable(),
    })
    .nullable(),
});

export const ListAutomationEntityModificationsResponseSchema = z.object({
  modifications: z.array(AutomationEntityModificationItemSchema),
});

export const automationEntityModificationsContracts = {
  list: oc
    .input(ListAutomationEntityModificationsInputSchema)
    .output(ListAutomationEntityModificationsResponseSchema)
    .route({
      method: "GET",
    }),
} as const;

export type ListAutomationEntityModificationsInput = z.infer<
  typeof ListAutomationEntityModificationsInputSchema
>;
export type AutomationEntityModificationItem = z.infer<
  typeof AutomationEntityModificationItemSchema
>;
export type ListAutomationEntityModificationsResponse = z.infer<
  typeof ListAutomationEntityModificationsResponseSchema
>;
